import {
  IconAdjustmentsHorizontal, IconAlertTriangle, IconApi, IconArrowsExchange, IconBuildingBank, IconBuildingSkyscraper,
  IconChartLine, IconChecks, IconCreditCard, IconFileInvoice, IconFileText, IconGitMerge, IconHeartHandshake, IconHome,
  IconKey, IconLayoutDashboard, IconLifebuoy, IconListDetails, IconMail, IconPlug, IconReceipt2, IconRoute, IconScale,
  IconServer, IconSettings, IconShieldCheck, IconShieldLock, IconShoppingCart, IconBed, IconUsers, IconUserShield,
  IconWebhook, IconLink, IconBuildingStore, IconRocket, IconSearch, IconDeviceDesktopAnalytics, IconAddressBook, IconLock,
  IconCalendar, IconUpload, IconPackage, IconDoor, IconCash, IconUsersGroup, IconSpeakerphone, IconBell, IconWorld, IconUserCircle, IconPalette,
  type Icon,
} from '@tabler/icons-react';

const MAP: Record<string, Icon> = {
  overview: IconLayoutDashboard, home: IconHome, txn: IconArrowsExchange, dispute: IconAlertTriangle, check: IconChecks,
  payout: IconBuildingBank, settle: IconFileText, recon: IconGitMerge, report: IconChartLine, connector: IconPlug,
  settings: IconSettings, audit: IconShieldCheck, payments: IconCreditCard, org: IconBuildingSkyscraper, ops: IconShieldLock,
  users: IconUsers, roles: IconUserShield, key: IconKey, paylink: IconLink, webhook: IconWebhook, api: IconApi, security: IconLock,
  bu: IconBuildingStore, profile: IconAddressBook, tenants: IconBuildingSkyscraper, onboarding: IconRocket,
  providers: IconPlug, routing: IconRoute, ledger: IconScale, config: IconAdjustmentsHorizontal, templates: IconMail,
  monitoring: IconDeviceDesktopAnalytics, services: IconServer, search: IconSearch, support: IconLifebuoy,
  smartbill: IconFileInvoice, retail: IconShoppingCart, giving: IconHeartHandshake, stay: IconBed, invoice: IconReceipt2,
  list: IconListDetails, calendar: IconCalendar, upload: IconUpload, catalog: IconPackage, rooms: IconDoor,
  collect: IconCash, customers: IconUsersGroup, campaign: IconSpeakerphone, bell: IconBell, globe: IconWorld, account: IconUserCircle,
  brand: IconPalette,
};

export function NavIcon({ name, size = 17, color }: { name: string; size?: number; color?: string }) {
  const C = MAP[name] ?? IconListDetails;
  return <C size={size} stroke={1.8} color={color} aria-hidden />;
}
